import { type Components } from '@mui/material'
export const Slider: Partial<Components> = {
  MuiSlider: {
    styleOverrides: {
      root: {
        '& .MuiSlider-thumb': {
          width: '33px',
          height: '33px',
          color: 'success.main',
          borderRadius: '5px'
        },
        '& .MuiSlider-valueLabel': {
          color: '#3F5073',
          background: 'unset',
          border: '2px solid #D9D9D9',
          backgroundColor: '#FFF',
          borderRadius: '5px',
          '&:before': {
            borderRight: '2px solid #D9D9D9',
            borderBottom: '2px solid #D9D9D9'
          }
        },
        '& .MuiSlider-rail': {
          color: '#d8d8d8'
        }
      }
    }
  }
}
